export class PostContactsLiensMRelations {
  public relation?: string;
  public premierDescription?: string;
  public secondDescription?: string;
  public typeMasterSlave?: number;
  public flagDelete?: number;
}
